var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.042 12.2472C44.5119 10.2668 42.9555 8.71047 40.9751 8.18034C37.3854 7.21854 23 7.21854 23 7.21854C23 7.21854 8.61459 7.21854 5.02865 8.18034C3.04824 8.71047 1.49193 10.2668 0.961804 12.2472C0 15.8331 0 23.3193 0 23.3193C0 23.3193 0 30.8055 0.961804 34.3914C1.49193 36.3718 3.04824 37.9281 5.02865 38.4582C8.61459 39.4201 23 39.4201 23 39.4201C23 39.4201 37.3854 39.4201 40.9714 38.4582C42.9518 37.9281 44.5081 36.3718 45.0382 34.3914C46 30.8055 46 23.3193 46 23.3193C46 23.3193 46 15.8331 45.0382 12.2472H45.042Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3992 30.2186L30.3536 23.3193L18.3992 16.4201V30.2186Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.a3edb442d058fe6064ecf44c10989cf0.svg";
export { ForwardRef as ReactComponent };